/*
 * Pipeline Theme
 *
 * Use this file to add custom Javascript to Pipeline.  Keeping your custom
 * Javascript in this fill will make it easier to update Pipeline. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 *
 */

/*
(function() {

  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.


  document.addEventListener('theme:variant:change', function(event) {
    // You might use something like this to write a pre-order feature or a
    // custom swatch feature.
    var variant = event.detail.variant;
    var container = event.target;
    if (variant) {
      console.log('Container ———————— ↓');
      console.log(container);
      console.log('Variant —————————— ↓');
      console.log(variant);
      // ... update some element on the page
    }
  });

  document.addEventListener('theme:cart:change', function(event) {
    var cart = event.detail.cart;
    if (cart) {
      console.log('Cart ———————————— ↓');
      console.log(cart);
      // ... update an app or a custom shipping caluclator
    }
  });
  // Fired when page loads to update header values
  document.addEventListener('theme:cart:init', (e) => {
    console.log('theme:cart:init');
    console.log(e);
  });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  document.addEventListener('theme:scroll', e => { console.log(e); });
  document.addEventListener('theme:scroll:up', e => { console.log(e); });
  document.addEventListener('theme:scroll:down', e => { console.log(e); });

  // Debounced resize listener to bundle changes that trigger document reflow
  document.addEventListener('theme:resize', e => { console.log(e); });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the 
  // scroll locking code knows what element should maintain scoll. 
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));


  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.


})();
*/
$(document).ready(function () {
  // Note: Radio → hidden property syncing is handled centrally by the portable
  // validation rules (`assets/product-add-validation-*.js`) right before add-to-cart.
  // custom.js only manages UI concerns (e.g., showing/hiding conditional questions).

  // Vehicle details display helper: keeps the "Confirm selection." hint in sync with the chosen radio.
  // Targets: <span class="vehicle-details-display" data-field-details="...">
  // Sources: <input type="radio" data-custom-order-data-radio="...">
  var VEHICLE_DETAILS_FALLBACK = "Confirm selection.";

  function updateVehicleDetailsDisplay(key) {
    if (!key) return;
    var $target = $('[data-field-details="' + key + '"]');
    if (!$target.length) return;
    var selectedValue = (
      $('input[type="radio"][data-custom-order-data-radio="' + key + '"]:checked').val() || ""
    ).trim();
    $target.text(selectedValue || VEHICLE_DETAILS_FALLBACK);
  }

  function initVehicleDetailsDisplays() {
    $('[data-field-details]').each(function () {
      var key = ($(this).attr("data-field-details") || "").trim();
      if (!key) return;
      updateVehicleDetailsDisplay(key);
    });
  }

  $(document).on("change", 'input[type="radio"][data-custom-order-data-radio]', function () {
    var key = ($(this).attr("data-custom-order-data-radio") || "").trim();
    updateVehicleDetailsDisplay(key);
  });
  $(document).on("shopify:section:load", initVehicleDetailsDisplays);
  $(document).on("shopify:section:select", initVehicleDetailsDisplays);
  initVehicleDetailsDisplays();

  var $tourPackRadios = $("input.properties_radio_tour_pack");
  var $tourPackSoloRadios = $(".properties_radio_tour_pack_solo");
  var $tourPackSoloInput = $("#properties-tour-pack-solo");
  var $tourPackSoloWrapper = $(".tour-pack-solo-radio");
  var $tourPackSoloRequiredText = $("#required_text_tour_pack_solo");

  function toggleTourPackSolo(hasTourPack) {
    if (!$tourPackSoloWrapper.length || !$tourPackSoloInput.length) return;
    if (hasTourPack) {
      $tourPackSoloWrapper.show();
      $tourPackSoloRadios.prop("disabled", false);
      $tourPackSoloInput.prop("disabled", false).addClass("required-properties");
    } else {
      $tourPackSoloWrapper.hide();
      $tourPackSoloRadios.prop("checked", false).prop("disabled", true);
      $tourPackSoloInput
        .prop("disabled", true)
        .removeClass("required-properties")
        .val("");
      $tourPackSoloRequiredText.hide();
      $tourPackSoloInput.removeClass("focused-error").css("borderColor", "#aaa");
    }
  }

  function applyTourPackValue() {
    var selectedTourPack = ($tourPackRadios.filter(":checked").val() || "").trim();
    var hasTourPack = selectedTourPack.toLowerCase() === "yes";
    toggleTourPackSolo(hasTourPack);
  }

  if ($tourPackRadios.length) {
    // Ensure solo question stays hidden until explicitly needed
    toggleTourPackSolo(false);
    $(document).on(
      "change",
      "input.properties_radio_tour_pack",
      applyTourPackValue
    );
    applyTourPackValue();
  }

  if ($("input.properties_radio_30").length) {
    $(document).on("change", ".properties_radio_30", function () {
      var arr = $(".properties_radio_30:checked")
        .map(function () {
          return this.value;
        })
        .get();
      $("#properties-30").val(arr);
    });
  }

  // Vehicle selection validation: ensures chosen year/make/model is in the allowed combos.
  function normalizeValue(val) {
    return (val || "").toString().trim();
  }

  function normalizeKey(val) {
    return normalizeValue(val).toLowerCase();
  }

  function parseVehicleCombos(raw, logFn) {
    if (!raw) return [];
    var source = raw;
    if (typeof raw === "string") {
      source = raw.trim();
      if (!source) return [];
      try {
        source = JSON.parse(source);
      } catch (e) {
        if (typeof logFn === "function") {
          logFn("JSON parse failed for vehicle combos", {
            rawLength: raw.length,
            rawSample: raw.slice(0, 200),
            error: e,
          });
        }
        return [];
      }
    }
    if (!Array.isArray(source)) return [];
    var combos = [];
    source.forEach(function (entry) {
      if (!entry) return;
      var yearsField =
        entry.year !== undefined && entry.year !== null ? entry.year : entry.years;
      var years = [];
      if (Array.isArray(yearsField)) {
        years = yearsField;
      } else if (typeof yearsField === "string") {
        years = yearsField.split(",");
      } else if (yearsField || yearsField === 0) {
        years = [yearsField];
      }
      if (!years.length) {
        years = [""];
      }
      var make = normalizeValue(entry.make);
      var model = normalizeValue(entry.model);
      years.forEach(function (y) {
        var yearValue = normalizeValue(y);
        if (yearValue || make || model) {
          combos.push({ year: yearValue, make: make, model: model });
        }
      });
    });
    return combos;
  }

  function initVehicleValidation() {
    var containers = document.querySelectorAll("[data-vehicle-selectors]");
    if (!containers.length) return;

    var debugFlag =
      typeof window.vehicleValidationDebug !== "undefined"
        ? !!window.vehicleValidationDebug
        : true; // default verbose logging on
    function debugLog() {
      if (!debugFlag) return;
      var args = Array.prototype.slice.call(arguments);
      args.unshift("[vehicle-validation]");
      console.log.apply(console, args);
    }

    var validators = [];

    containers.forEach(function (container) {
      var warningEl =
        container.querySelector("[data-vehicle-warning]") ||
        document.querySelector("[data-vehicle-warning]");
      var yearSelect = container.querySelector("[data-vehicle-year]");
      var makeSelect = container.querySelector("[data-vehicle-make]");
      var modelSelect = container.querySelector("[data-vehicle-model]");
      var hiddenVehicle = document.getElementById("properties-vehicle");
      var combosRaw = container.getAttribute("data-vehicle-combos") || "";
      if (!combosRaw) {
        debugLog("No data-vehicle-combos attribute found or empty.", {
          container: container,
        });
      }
      var parsedCombos = parseVehicleCombos(combosRaw, debugLog);
      // Fallback: build combos from data attributes (metafield fallback), not from DOM options
      if (!parsedCombos.length) {
        var yearsAttr = container.getAttribute("data-vehicle-years") || "[]";
        var makesAttr = container.getAttribute("data-vehicle-makes") || "[]";
        var modelsAttr = container.getAttribute("data-vehicle-models") || "[]";
        var yearsArr = [];
        var makesArr = [];
        var modelsArr = [];
        try {
          yearsArr = JSON.parse(yearsAttr);
          makesArr = JSON.parse(makesAttr);
          modelsArr = JSON.parse(modelsAttr);
        } catch (e) {
          debugLog("Failed to parse vehicle Y/M/M attributes", e);
        }
        var combosFromAttr = [];
        yearsArr.forEach(function (y) {
          makesArr.forEach(function (m) {
            modelsArr.forEach(function (mdl) {
              combosFromAttr.push({
                year: normalizeValue(y),
                make: normalizeValue(m),
                model: normalizeValue(mdl),
              });
            });
          });
        });
        parsedCombos = combosFromAttr;
        debugLog("Built fallback combos from metafield arrays", {
          years: yearsArr,
          makes: makesArr,
          models: modelsArr,
          count: combosFromAttr.length,
          sample: combosFromAttr.slice(0, 5),
        });
      }
      debugLog("Parsed combos", {
        container: container,
        rawSample: combosRaw ? combosRaw.slice(0, 200) : "",
        parsedCount: parsedCombos.length,
        sample: parsedCombos.slice(0, 5),
      });
      var normalizedCombos = parsedCombos.map(function (c) {
        return {
          year: normalizeKey(c.year),
          make: normalizeKey(c.make),
          model: normalizeKey(c.model),
        };
      });
      debugLog("Normalized combos", {
        parsedCount: parsedCombos.length,
        normalizedSample: normalizedCombos.slice(0, 5),
      });

      var allowedYears = new Set();
      var allowedMakes = new Set();
      var allowedModels = new Set();
      normalizedCombos.forEach(function (c) {
        if (c.year) allowedYears.add(c.year);
        if (c.make) allowedMakes.add(c.make);
        if (c.model) allowedModels.add(c.model);
      });

      function setWarning(message) {
        if (!warningEl) return;
        if (message) {
          warningEl.textContent = message;
          warningEl.style.display = "block";
          warningEl.style.color = "#b45309";
        } else {
          warningEl.textContent = "";
          warningEl.style.display = "none";
        }
      }

      function getSelection() {
        return {
          year: normalizeValue(yearSelect && yearSelect.value),
          make: normalizeValue(makeSelect && makeSelect.value),
          model: normalizeValue(modelSelect && modelSelect.value),
          yearEl: yearSelect,
          makeEl: makeSelect,
          modelEl: modelSelect,
        };
      }

      function validate(showMessage) {
        var selection = getSelection();
        var yearKey = normalizeKey(selection.year);
        var makeKey = normalizeKey(selection.make);
        var modelKey = normalizeKey(selection.model);
        var message = "";
        debugLog("Start validate", {
          selection: selection,
          normalized: { year: yearKey, make: makeKey, model: modelKey },
          allowedYears: Array.from(allowedYears).slice(0, 10),
          allowedMakes: Array.from(allowedMakes).slice(0, 10),
          allowedModels: Array.from(allowedModels).slice(0, 10),
        });

        // If no combo data is present, treat as valid (fall back to required check).
        if (!normalizedCombos.length) {
          debugLog("No combo data present; treating as valid.");
          if (showMessage !== false) {
            setWarning("");
          }
          return {
            valid: true,
            message: "",
            container: container,
            focusEl: selection.yearEl || selection.makeEl || selection.modelEl,
          };
        }

        if (selection.year && !allowedYears.has(yearKey)) {
          message = "Selected year is not available for this product.";
        } else if (selection.make && !allowedMakes.has(makeKey)) {
          message = "Selected make is not available for this product.";
        } else if (selection.model && !allowedModels.has(modelKey)) {
          message = "Selected model is not available for this product.";
        } else if (selection.year && selection.make && selection.model) {
          var comboMatch = normalizedCombos.some(function (c) {
            return c.year === yearKey && c.make === makeKey && c.model === modelKey;
          });
          if (!comboMatch) {
            message =
              "This year, make, and model combination is not a valid vehicle for this product.";
          }
        }

        var valid = !message;
        debugLog("Validate selection", {
          selection: selection,
          normalized: { year: yearKey, make: makeKey, model: modelKey },
          valid: valid,
          message: message,
        });
        if (showMessage !== false) {
          setWarning(message);
        }

        if (container) {
          container.dataset.vehicleValid = valid ? "true" : "false";
        }

        return {
          valid: valid,
          message: message,
          container: container,
          focusEl:
            (!valid && (selection.yearEl || selection.makeEl || selection.modelEl)) ||
            null,
          warningEl: warningEl,
        };
      }

      function handleSelectionChange() {
        validate(true);
      }

      ["change", "input"].forEach(function (evt) {
        if (yearSelect) yearSelect.addEventListener(evt, handleSelectionChange);
        if (makeSelect) makeSelect.addEventListener(evt, handleSelectionChange);
        if (modelSelect) modelSelect.addEventListener(evt, handleSelectionChange);
      });

      // Initial pass without showing a message
      validate(false);

      validators.push({
        container: container,
        validate: validate,
      });
    });

    window.validateVehicleSelection = function (options) {
      var opts = options || {};
      var showMessage = opts.showMessage !== false;
      var targetContainer = opts.container || null;
      if (!validators.length) {
        return { valid: true, message: "" };
      }
      var chosen =
        (targetContainer &&
          validators.find(function (v) {
            return v.container === targetContainer;
          })) ||
        validators[0];
      debugLog("Manual validateVehicleSelection call", {
        showMessage: showMessage,
        container: chosen.container,
      });
      return chosen.validate(showMessage);
    };

    // Expose validators for debugging if needed
    window.__vehicleValidators = validators;
  }

  initVehicleValidation();
});

(function () {
  if (window.__disableGspfFilterLabels) return;

  var labelTargets = [
    {
      selector:
        '#gf-tree div[data-filter-type*="metafield:attributes:make"] select option:first-child',
      text: "Make",
    },
    {
      selector:
        '#gf-tree div[data-filter-type*="metafield:attributes:model"] select option:first-child',
      text: "Model",
    },
  ];
  var observer = null;
  var scheduled = false;
  var lastRoot = null;

  function applyFilterLabels() {
    scheduled = false;
    var root = document.querySelector("#gf-tree");
    if (!root) return;
    lastRoot = root;
    for (var i = 0; i < labelTargets.length; i++) {
      var entry = labelTargets[i];
      var options = root.querySelectorAll(entry.selector.replace("#gf-tree ", ""));
      for (var j = 0; j < options.length; j++) {
        var option = options[j];
        // Only fill empty placeholders; avoid fighting Globo for dynamically
        // rendered dropdowns (can cause excessive re-renders and lockups).
        var current = option && typeof option.textContent === "string"
          ? option.textContent.trim()
          : "";
        if (option && (current === "" || current === "Select") && option.textContent !== entry.text) {
          option.textContent = entry.text;
        }
      }
    }
  }

  function scheduleApply() {
    if (scheduled) return;
    scheduled = true;
    if (typeof requestAnimationFrame === "function") {
      requestAnimationFrame(applyFilterLabels);
    } else {
      setTimeout(applyFilterLabels, 0);
    }
  }

  // Immediate attempt before anything else runs so we don't wait on mutations.
  scheduleApply();
  // Microtask fallback in case DOM finishes syncing after this script executes.
  setTimeout(scheduleApply, 0);

  function startFilterLabelObserver() {
    if (observer) return;
    observer = new MutationObserver(function () {
      // Only react to changes within the Globo filter tree to avoid doing work
      // on unrelated DOM mutations across the page.
      var root = document.querySelector("#gf-tree");
      if (!root) return;
      if (lastRoot !== root) {
        lastRoot = root;
      }
      scheduleApply();
    });

    var root = document.querySelector("#gf-tree");
    if (root) {
      lastRoot = root;
      observer.observe(root, { childList: true, subtree: true });
      return;
    }

    // Fallback: observe the body until #gf-tree exists, then re-bind.
    if (document.body) {
      observer.observe(document.body, { childList: true, subtree: true });
      var timer = setInterval(function () {
        var nextRoot = document.querySelector("#gf-tree");
        if (!nextRoot) return;
        clearInterval(timer);
        try {
          observer.disconnect();
        } catch (e) {}
        lastRoot = nextRoot;
        observer.observe(nextRoot, { childList: true, subtree: true });
        scheduleApply();
      }, 250);
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", startFilterLabelObserver);
  } else {
    startFilterLabelObserver();
  }

  // Re-apply after Globo re-renders the filter tree (e.g., when Model options refresh).
  window.addEventListener("globoFilterRenderCompleted", scheduleApply);
  window.addEventListener("globoFilterRenderSearchCompleted", scheduleApply);
  window.addEventListener("globoFilterSearchCompleted", scheduleApply);
})();

// Purpose: cache api calls from Globo filter (300,000+ lines). Only updates when needed.
(function () {
  const CACHE_TTL_MS = 6 * 60 * 60 * 1000; // 6h
  const HOST = 'filter-u4.globo.io';
  const CACHE_NAME = "gspf-fetch-cache-v1";
  const TS_HEADER = "x-gspf-cached-at";

  if (window.__disableGspfFetchCache) return;
  if (window.__gspfFetchCacheInstalled) return;
  window.__gspfFetchCacheInstalled = true;

  function makeKeyUrl(url) {
    const u = new URL(url);
    // Strip request-unique params to improve cache hits
    ['oseid', 'cid', 'did', '_', 'timestamp'].forEach(p => u.searchParams.delete(p));
    u.searchParams.sort();
    u.hash = "";
    return u.toString();
  }

  const originalFetch = window.fetch;
  window.fetch = async function (input, init) {
    try {
      if (window.__disableGspfFetchCache) {
        return originalFetch.apply(this, arguments);
      }

      const url = typeof input === 'string' ? input : input.url;
      const method =
        (init && init.method) || (input && input.method) || "GET";

      if (
        url &&
        url.includes(HOST) &&
        String(method).toUpperCase() === "GET" &&
        typeof caches !== "undefined" &&
        typeof caches.open === "function" &&
        typeof Request === "function"
      ) {
        const keyUrl = makeKeyUrl(url);
        const keyRequest = new Request(keyUrl, { method: "GET" });
        const cache = await caches.open(CACHE_NAME);
        const cached = await cache.match(keyRequest);

        if (cached) {
          const cachedAtRaw = cached.headers.get(TS_HEADER);
          const cachedAt = cachedAtRaw ? Number(cachedAtRaw) : 0;
          if (cachedAt && Date.now() - cachedAt < CACHE_TTL_MS) {
            return cached.clone();
          }
          await cache.delete(keyRequest);
        }

        const res = await originalFetch.apply(this, arguments);

        // Store without forcing a full-body read (avoids main-thread lockups).
        if (res && res.ok && res.type !== "opaque" && res.body) {
          const headers = new Headers(res.headers);
          headers.set(TS_HEADER, String(Date.now()));
          const cacheRes = new Response(res.clone().body, {
            status: res.status,
            statusText: res.statusText,
            headers,
          });
          cache.put(keyRequest, cacheRes).catch(function () {});
        }

        return res;
      }
    } catch (e) {
      console.warn('YMM fetch cache fallback', e);
    }
    return originalFetch.apply(this, arguments);
  };
})();

// Cleanup: remove legacy localStorage cache entries from the older Globo fetch cache implementation.
(function () {
  try {
    if (typeof localStorage === "undefined" || !localStorage) return;
    var keys = [];
    for (var i = 0; i < localStorage.length; i++) {
      var key = localStorage.key(i);
      if (key && key.indexOf("gspf:") === 0) keys.push(key);
    }
    if (!keys.length) return;

    var idx = 0;
    function removeChunk(deadline) {
      var start = Date.now();
      while (
        idx < keys.length &&
        ((deadline && typeof deadline.timeRemaining === "function"
          ? deadline.timeRemaining() > 5
          : Date.now() - start < 10))
      ) {
        try {
          localStorage.removeItem(keys[idx]);
        } catch (e) {}
        idx++;
      }

      if (idx < keys.length) {
        if (typeof requestIdleCallback === "function") {
          requestIdleCallback(removeChunk);
        } else {
          setTimeout(removeChunk, 50);
        }
      }
    }

    if (typeof requestIdleCallback === "function") {
      requestIdleCallback(removeChunk);
    } else {
      setTimeout(removeChunk, 50);
    }
  } catch (e) {}
})();

// Purpose: Redirect users from the generic /products page to /collections/all for a better Browse experience.
(function () {
  "use strict"; // Optional: Enforces stricter parsing and error handling

  const currentPath = window.location.pathname;

  // Log for debugging if needed, can be removed for production
  // console.log('Checking path for redirect: ' + currentPath);

  if (currentPath === "/products") {
    // Use strict equality '==='
    window.location.href = "/collections/all";
  }
})();
